import React from "react";
import { NavLink } from "react-router-dom";

import {bookAppointment} from '../api'

import { CalendarComponent } from "@syncfusion/ej2-react-calendars";
import { toast } from "react-toastify";
import "./AddAppointment.css";

class AddAppointment extends React.Component {
  state = {
    date: "",
    hour: '',
  };

  calendarChange = (event) => {

    this.setState({
      date: event.target.value
    })
  }

  hoursChange = (event) => {
    this.setState({
      hour: event.target.innerText
    })
  }

  submitForm = async (event) => {
event.preventDefault()
    const {date, hour} = this.state
    const {name, icon} = this.props.location.place
    const appointment = {
      date,
      hour,
      name,
      icon
    }
   await bookAppointment(appointment)
   toast.dark(`${this.props.location.place.name} appointment has been scheduled!`);
   this.props.history.push('/appointments')
  }

  render() {
    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/map">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Book Your Appointment</h1>
        </div>

        <form className="formAppBox">
          <section className="appBox">
            <div>
            <img src="/images/locationlogo.png" />
              <h2>{this.props.location.place.name}</h2>
              <p>{this.props.location.place.icon}</p>
            </div>
          </section>

          <div className="calendarBox">
            <CalendarComponent onChange={this.calendarChange} value={this.state.date} />
          </div>

          <div  className="hoursBox">
            <p onClick={this.hoursChange} >08:00</p>
            <p  onClick={this.hoursChange}>09:00</p>
            <p  onClick={this.hoursChange}>10:00</p>
            <p  onClick={this.hoursChange}>11:00</p>
            <p  onClick={this.hoursChange}>12:00</p>
            <p  onClick={this.hoursChange}>13:00</p>
            <p  onClick={this.hoursChange}>14:00</p>
            <p  onClick={this.hoursChange}>15:00</p>
            <p  onClick={this.hoursChange}>16:00</p>
            <p  onClick={this.hoursChange}>17:00</p>
            <p  onClick={this.hoursChange}>18:00</p>
          </div>

          <button className="formCalendarButton" onClick={this.submitForm}>Confirm</button>
        </form>
      </main>
    );
  }
}

export default AddAppointment;
